import { BaseRequest } from './BaseRequest';

export class RulesRequest extends BaseRequest {
    
}